/* eslint-disable import/default */
import React from 'react';
import {render} from 'react-dom';
import {Provider} from 'react-redux';
import {Router, browserHistory} from 'react-router';
import {syncHistoryWithStore} from 'react-router-redux';

import 'babel-polyfill';

import routes from './routes';
import configureStore from './config/configureStore';
import configureLanguages from './config/configureLanguages';

require('./favicon.ico');
import './styles/styles.scss'; 

const store = configureStore();

// determine the user browser language and set accordingly
let browserLanguage = window.navigator.language;
browserLanguage = browserLanguage.substring(0, 2);
//if(browserLanguage === 'de')
//{
	browserLanguage = 'de-DE';
//} else {
//	browserLanguage = 'en-US';
//}

// Configure the i18n translations
configureLanguages(store, browserLanguage);

// Create an enhanced history that syncs navigation events with the store
const history = syncHistoryWithStore(browserHistory, store);

render(
  <Provider store={store}>
    <Router history={history} routes={routes} />
  </Provider>, document.getElementById('app')
);



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/